module.exports = __webpack_public_path__ + "img/logo_horizontal_white.d75e1aa0.svg";